import React from "react";
import Hero from "./Hero";
import FormSection from "./FormSection";

const Carasoul = () => {
  const containerStyle = {
    backgroundImage: "url('./banner_desktop.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    padding: "60px 0",
    minHeight: "100vh",
  };

  return (
    <div style={containerStyle}>
      <div className="container">
        <div className="row align-items-start">
          {/* LEFT SECTION - HERO */}
          <div className="col-lg-8 mb-4 mb-lg-0">
            <Hero />
          </div>

         {/* RIGHT SECTION - FORM */}
<div className="col-lg-4" style={{ marginTop: "40px" }}>
  <FormSection />
</div>

        </div>
      </div>
    </div>
  );
};

export default Carasoul;
